import api from './api';

// News on the user's own tickers (2026-10-04). The backend classifies every
// article (major / release / news / opinion / filler) and hides filler unless
// asked; see backend/services/news_feed.py.

export const getNewsFeed = ({ portfolio = [], watch = [], extra = [], includeFiller = false } = {}) => {
  const params = {};
  if (portfolio.length) params.portfolio = portfolio.join(',');
  if (watch.length) params.watch = watch.join(',');
  if (extra.length) params.extra = extra.join(',');
  if (includeFiller) params.include_filler = true;
  return api.get('/news/feed', { params }).then((r) => r.data);
};

export const getTickerNews = (symbol, limit = 3) =>
  api.get(`/news/ticker/${encodeURIComponent(symbol)}`, { params: { limit } }).then((r) => r.data);
